<svg width="14" height="22" fill="none">
    <rect width="12" height="20" x="1" y="1" stroke="#5B6971" stroke-width="1.2" rx="1.5" />
    <path stroke="#5B6971" stroke-linecap="round" stroke-width="1.2" d="M5 4h4" />
    <circle cx="7" cy="17.5" r="1" fill="#5B6971" />
</svg>
